import React from "react";
import photo from "../assets/IMG_20190916_144203small.jpg";
import { Link } from "react-scroll";

const AboutMe = () => {
  return (
    <div id="about" className="about-me">
      <div className="container py-5">
        <div className="row">
          <div className="col-lg-6 col-xm-12">
            <h1 className="about-heading">About Me</h1>
            <p>
              Jennifer Kramer was born and raised in South Florida and has been
              in the Visual Arts field for well over 10 years. She went to a
              magnet high school named Dreyfoos School of the Arts in West Palm
              Beach, Florida then attended Florida Atlantic University shortly
              after and graduated with a Bachelor of Arts degree with a major in
              Studio Art and a minor in Sociology.
            </p>
            <p>
              Currently, she has recently graduated from an intensive remote
              coding bootcamp, called Lambda School, which focuses on full-stack
              web development and computer science. Jennifer researches outside
              of school for deeper understanding of the material she has learned
              and implemented in her projects as well as experiment with new
              languages and libraries in relation to coding. She is currently on
              the lookout for design-related fields that collaborate with coding
              such as: React Front-End Developer, Web Designer, and UX/UI
              Designer.
            </p>
            <p>
              If you're interested in working with her, tap or click&nbsp;
              <Link
                smooth={true}
                to="contact"
                offset={-100}
                href="#"
                className="contact-me"
              >
                here
              </Link>
              &nbsp;to contact her directly.
            </p>
          </div>
          <div className="col-lg-6 col-xm-12">
            <div className="photo-wrap mb-5">
              <img
                className="profile-img"
                src={photo}
                alt="Photo of Jennifer Kramer"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutMe;
